import { siteUrl, socialButtons } from '@config'
import { ConfigSiteContext } from '@contexts/config-site'
import { useContext } from 'react'
import { type Organization } from 'schema-dts'

export const useOrganization = (): Organization => {
  const { defaultImage } = useContext(ConfigSiteContext)

  const data: Organization = {
    '@type': 'Organization',
    name: 'Fortuneo',
    url: siteUrl,
    sameAs: socialButtons.map((social) => social.href),
    address: {
      '@type': 'PostalAddress',
      streetAddress: '5, place de la Pyramide',
      addressLocality: 'PUTEAUX, FRANCE',
      addressRegion: 'IDF',
      postalCode: '92800',
      addressCountry: 'FR',
    },
  }

  if (defaultImage?.file) {
    const { url, details } = defaultImage.file
    data.logo = {
      '@type': 'ImageObject',
      url,
    }
    if (details?.image) {
      const { width, height } = details.image
      data.logo.width = `${width}px`
      data.logo.height = `${height}px`
    }
  }

  return data
}
